module.exports = __webpack_public_path__ + "static/f4e6a6ef0397c669a196bef8e118891af93d851acb07334db306f9c683e0b523-cc4a2ba27a789149f0a9a0f85d362015.png";